module.exports = __webpack_public_path__ + "images/file_icons_v2/xlsx-b09aaa4446161689d426268b5dd66a50.svg";